import { z } from 'zod';

export const itemCustomFieldDateValueSchema = z
  .object({
    year: z.number().int().optional(),
    month: z.number().int().optional(),
    day: z.number().int().optional(),
  })
  .strict()
  .refine(
    (value) => value.year !== undefined || value.month !== undefined || value.day !== undefined,
    {
      message: 'At least one date part is required',
    },
  );

export const itemCustomFieldPrimitiveValueSchema = z.union([
  z.string(),
  z.number(),
  z.boolean(),
  itemCustomFieldDateValueSchema,
]);

export const itemCustomFieldValueWithDescriptionSchema = z
  .object({
    value: itemCustomFieldPrimitiveValueSchema,
    description: z.string(),
  })
  .strict();

export const itemCustomFieldSingleValueSchema = z.union([
  itemCustomFieldPrimitiveValueSchema,
  itemCustomFieldValueWithDescriptionSchema,
]);

export const itemCustomFieldMultiValueEntrySchema = z
  .object({
    id: z.number().int().positive(),
    value: itemCustomFieldPrimitiveValueSchema,
  })
  .strict();

export const itemCustomFieldValueSchema = z.union([
  itemCustomFieldSingleValueSchema,
  z.array(z.union([itemCustomFieldSingleValueSchema, itemCustomFieldMultiValueEntrySchema])),
  z.null(),
]);

export const itemCustomFieldValuesSchema = z.record(z.string(), itemCustomFieldValueSchema);

export type ItemCustomFieldValueDTO = z.infer<typeof itemCustomFieldValueSchema>;
export type ItemCustomFieldValuesDTO = z.infer<typeof itemCustomFieldValuesSchema>;

export type ItemCustomFieldDateValueDTO = z.infer<typeof itemCustomFieldDateValueSchema>;
export type ItemCustomFieldPrimitiveValueDTO = z.infer<typeof itemCustomFieldPrimitiveValueSchema>;
export type ItemCustomFieldValueWithDescriptionDTO = z.infer<
  typeof itemCustomFieldValueWithDescriptionSchema
>;
export type ItemCustomFieldSingleValueDTO = z.infer<typeof itemCustomFieldSingleValueSchema>;
export type ItemCustomFieldMultiValueEntryDTO = z.infer<
  typeof itemCustomFieldMultiValueEntrySchema
>;
